"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DecimalMysqlHandler", {
    enumerable: true,
    get: function() {
        return DecimalMysqlHandler;
    }
});
const _decimalgeneralhandler = require("./decimal.general.handler");
const _genericmysql = require("~/db/field-handler/handlers/generic.mysql");
let DecimalMysqlHandler = class DecimalMysqlHandler extends _genericmysql.GenericMysqlFieldHandler {
    constructor(...args){
        super(...args), this.decimalGeneralHandler = new _decimalgeneralhandler.DecimalGeneralHandler(), this.select = this.decimalGeneralHandler.select, this.filter = this.decimalGeneralHandler.filter, this.verifyFilter = this.decimalGeneralHandler.verifyFilter, this.parseUserInput = this.decimalGeneralHandler.parseUserInput, this.parseDbValue = this.decimalGeneralHandler.parseDbValue, this.filterBlank = this.decimalGeneralHandler.filterBlank, this.filterNotblank = this.decimalGeneralHandler.filterNotblank, this.filterNeq = this.decimalGeneralHandler.filterNeq;
    }
};
